<template>
  <div class="container-fluid dashboard">
    <div class="container-title flex-column flex-sm-row justify-content-start justify-content-sm-between align-items-sm-center mb-3 mb-sm-4">
      <h3 class="montserrat">{{ $t("page.main.dashboard") }}</h3>
      <!-- <h5 class="pt-1">{{ changeDate(tomonth) }}</h5> -->
      <div class="row g-0 mt-3 mt-sm-0">
        <input
          type="month"
          class="form-control-md"
          v-model="searchData.regdate"
        />
      </div>
    </div>

    <div class="main_wrap">
      <div class="row">
        <div class="col-lg-4">
          <p>
            <strong class="fw-500 text-black">{{ $t("title.main.member") }}</strong>
            <small>
              ({{ $t("title.main.month") }} :
              {{ playercntmonth | comma }}/ {{ $t("title.main.total") }} :
              {{ playercnttotal | comma }})
            </small>
          </p>
          <barchart :chartlabel="chart1_labels" :chartdata="chart1_data" />
        </div>
        <div class="col-lg-4">
          <p>
            <strong class="fw-500 text-black">{{ $t("title.main.owner") }}</strong>
            <small>
              ({{ $t("title.main.month") }} :
              {{ ownercntmonth | comma }}/ {{ $t("title.main.total") }} :
              {{ ownercnttotal | comma }})
            </small>
          </p>
          <barchart :chartlabel="chart2_labels" :chartdata="chart2_data" />
        </div>
        <div class="col-lg-4">
          <p>
            <strong class="fw-500 text-black">{{ $t("title.main.game_terminated") }}</strong>
            <small>
              ({{
                $t("title.main.month")
              }}
              : {{ gamestopcntmonth | comma }}/ {{ $t("title.main.total") }} :
              {{ gamestopcnttotal | comma }})
            </small>
          </p>
          <linechart :chartlabel="chart3_labels" :chartdata="chart3_data" />
        </div>
        <div class="col-lg-4">
          <p>
            <strong class="fw-500 text-black">{{ $t("title.main.game_end") }}</strong>
            <small>
              ({{ $t("title.main.month") }} :
              {{ gameendcntmonth | comma }}/ {{ $t("title.main.total") }} :
              {{ gameendcnttotal | comma }})
            </small>
          </p>
          <linechart :chartlabel="chart4_labels" :chartdata="chart4_data" />
        </div>
        <div class="col-lg-4">
          <p>
            <strong class="fw-500 text-black">{{ $t("title.main.tournament") }}</strong>
            <small>
              ({{ $t("title.main.month") }} :
              {{ tournamentcntmonth | comma }}/ {{ $t("title.main.total") }} :
              {{ tournamentcnttotal | comma }})
            </small>
          </p>
          <linechart :chartlabel="chart5_labels" :chartdata="chart5_data" />
        </div>
        <div class="col-lg-4">
          <p>
            <strong class="fw-500 text-black">{{ $t("title.main.minigame_winner") }}</strong>
            <small>
              ({{ $t("title.main.month") }} :
              {{ eventwinningcntmonth | comma }}/ {{ $t("title.main.total") }} :
              {{ eventwinningcnttotal | comma }})
            </small>
          </p>
          <linechart :chartlabel="chart6_labels" :chartdata="chart6_data" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ax from "@/api/main";
import "@/filter/common";
import barchart from "@/components/chart/BarChart";
import linechart from "@/components/chart/LineChart";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "Main",
  components: {
    barchart,
    linechart,
  },
  data() {
    return {
      searchData: {
        regdate:
          this.$route.query.regdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].regdate) ||
          this.$dayjs().format("YYYY-MM"),
      },

      tomonth: "",
      playercntmonth: 0,
      playercnttotal: 0,
      playerlist: [],
      ownercntmonth: 0,
      ownercnttotal: 0,
      ownerlist: [],
      gamestopcntmonth: 0,
      gamestopcnttotal: 0,
      gamestoplist: [],
      gameendcntmonth: 0,
      gameendcnttotal: 0,
      gameendlist: [],
      tournamentcntmonth: 0,
      tournamentcnttotal: 0,
      tournamentlist: [],
      eventwinningcntmonth: 0,
      eventwinningcnttotal: 0,
      eventwinninglist: [],
      chart1_labels: [],
      chart1_data: [],
      chart2_labels: [],
      chart2_data: [],
      chart3_labels: [],
      chart3_data: [],
      chart4_labels: [],
      chart4_data: [],
      chart5_labels: [],
      chart5_data: [],
      chart6_labels: [],
      chart6_data: [],
    };
  },
  mounted() {
    this.getMain();
  },
  methods: {
    getMain() {
      ax.getMain(this.searchData, (flag, data) => {
        if (flag) {
          this.tomonth = data.tomonth;
          this.playercntmonth = data.playercntmonth;
          this.playercnttotal = data.playercnttotal;
          this.playerlist = data.playerlist;
          this.ownercntmonth = data.ownercntmonth;
          this.ownercnttotal = data.ownercnttotal;
          this.ownerlist = data.ownerlist;
          this.gamestopcntmonth = data.gamestopcntmonth;
          this.gamestopcnttotal = data.gamestopcnttotal;
          this.gamestoplist = data.gamestoplist;
          this.gameendcntmonth = data.gameendcntmonth;
          this.gameendcnttotal = data.gameendcnttotal;
          this.gameendlist = data.gameendlist;
          this.tournamentcntmonth = data.tournamentcntmonth;
          this.tournamentcnttotal = data.tournamentcnttotal;
          this.tournamentlist = data.tournamentlist;
          this.eventwinningcntmonth = data.eventwinningcntmonth;
          this.eventwinningcnttotal = data.eventwinningcnttotal;
          this.eventwinninglist = data.eventwinninglist;

          this.chart1_labels = [];
          this.chart1_data = [];
          for (let i = 0; i < this.playerlist.length; i++) {
            this.chart1_labels[i] = this.playerlist[i].date;
            this.chart1_data[i] = parseInt(this.playerlist[i].cnt);
          }
          this.chart2_labels = [];
          this.chart2_data = [];
          for (let i = 0; i < this.ownerlist.length; i++) {
            this.chart2_labels[i] = this.ownerlist[i].date;
            this.chart2_data[i] = parseInt(this.ownerlist[i].cnt);
          }
          this.chart3_labels = [];
          this.chart3_data = [];
          for (let i = 0; i < this.gamestoplist.length; i++) {
            this.chart3_labels[i] = this.gamestoplist[i].date;
            this.chart3_data[i] = parseInt(this.gamestoplist[i].cnt);
          }
          this.chart4_labels = [];
          this.chart4_data = [];
          for (let i = 0; i < this.gameendlist.length; i++) {
            this.chart4_labels[i] = this.gameendlist[i].date;
            this.chart4_data[i] = parseInt(this.gameendlist[i].cnt);
          }
          this.chart5_labels = [];
          this.chart5_data = [];
          for (let i = 0; i < this.tournamentlist.length; i++) {
            this.chart5_labels[i] = this.tournamentlist[i].date;
            this.chart5_data[i] = parseInt(this.tournamentlist[i].cnt);
          }
          this.chart6_labels = [];
          this.chart6_data = [];
          for (let i = 0; i < this.eventwinninglist.length; i++) {
            this.chart6_labels[i] = this.eventwinninglist[i].date;
            this.chart6_data[i] = parseInt(this.eventwinninglist[i].cnt);
          }
        } else {
          this.$notify({
            group: "alert",
            type: "warn",
            title: "Notice",
            text: data.message,
          });
        }
      });
    },
  },
  watch: {
    "searchData.regdate": function () {
      this.getMain();
    },
  },
  mixins: [myMixin],
};
</script>